import { qs, qsa } from '../utils'
import bidello from '../bidello'
import gsap, { Power4 } from 'gsap'
import inspire from '../webgl/inspire/inspire'
import menu from '../menu'
import scroll from '../animations/scroll/locomotiveScroll'

export const archiveInspireTransition = {
  name: 'archive-inspire',

  to: {
    namespace: 'archive-inspire',
  },

  once({ next }) {
    const tl = animation(next.container)

    bidello.on('loaderEnd', () => {
      inspire.enter()
      tl.play()
    })
  },

  enter({ next, current }) {
    scroll.stop()
    current.container.style.display = 'none'

    const tl = animation(next.container)
    inspire.resetMeshes()
    inspire.enter()

    return tl.play()
  },

  leave({ next, current }) {
    if (menu.isOpen) {
      menu.menuLeave()
    }

    gsap.set(next.container, { autoAlpha: 0 })

    return gsap.to(current.container, {
      opacity: 0,
      duration: 1.2,
      onComplete: () => {
        scroll.scrollTo({ target: 0, options: { duration: 0, disableLerp: true } })
      }
    })
  }
}

const animation = (container) => {
  const title = qs('h1', container)

  const tl = gsap.timeline({ paused: true, delay: 1 })

  tl
    .set(container, { autoAlpha: 1 })
    .from(title, {
      duration: 1.6,
      autoAlpha: 0,
      filter: 'blur(20px)',
      ease: Power4.easeOut
    })

  return tl
}